var map = {
	"./black/piliangshanchu2.png": "MhE2",
	"./blue/piliangshanchu2.png": "wepC",
	"./white/piliangshanchu2.png": "F4ie"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "IjFR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/piliangshanchu2\.png$
// module id = IjFR
// module chunks = 24